// Medzcool "cytoplasm" design tokens, formerly installed from the
// @bit/medzcool.cytoplasm.colors and @bit/medzcool.cytoplasm.typography
// packages. Bit's legacy registry (node.bit.dev) is shut down, so the values
// live here now. Same values as medzcool-frontend's src/Cytoplasm.

// Fonts are loaded from Adobe Fonts (TypeKit ID: yim1brv).
export const fontFamily = {
  sansSerif: "futura-pt, sans-serif",
  serif: "adobe-garamond-pro, serif",
};

export const fontWeight = {
  light: 300,
  regular: 400,
  heavy: 500,
  bold: 700,
};

export const grayscale = {
  darkDark: "#333333",
  lightDark: "#999999",
  gray: "#D8D8D8",
  lightGray: "#F2F2F2",
  offWhite: "#FAFAFA",
};

export const red = {
  dark: "#D23D56",
  bright: "#F0445D",
  pink: "#fd2c9b",
};

export const green = {
  dark: "#008C82",
  bright: "#5ED1A5",
  limegreen: "#A6FF20",
};
